<template>
    <div id="membership-details-visits-tab"
         class="tab-contents tab-content">
        <PageLoadingSpinner v-if="loadingRedemptions"
                            color="light"
                            lang="MEMBERSHIP_DETAILS.LOADING" />

        <table v-if="redemptions !== null"
               class="dt-table">
            <thead>
                <tr>
                    <th>{{ l('MEMBERSHIP_DETAILS.DATE_LABEL') }}</th>
                    <th>{{ l('MEMBERSHIP_DETAILS.MEMBER_LABEL') }}</th>
                    <th>{{ l('MEMBERSHIP_DETAILS.TYPE_LABEL') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="redemption in paginatedRedemptions"
                    :key="redemption.ID">
                    <td>{{ formatDate(redemption.triggeredAt) }}</td>
                    <td>
                        <ContactNameWithTitle v-if="getMemberByContactID(redemption.contactID)"
                                              :contact="getMemberByContactID(redemption.contactID).contact" />
                    </td>
                    <td>
                        <span v-if="redemption.qty > 0"
                              class="indicator indicator-success">
                            {{ l('MEMBERSHIP_DETAILS.REDEMPTION') }}
                        </span>
                        <span v-else
                              class="indicator indicator-danger">
                            {{ l('MEMBERSHIP_DETAILS.UNREDEMPTION') }}
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>

        <div v-if="showPagination"
             class="footer-btn-bar visible">
            <div class="footer-btn-bar__left"></div>
            <div class="footer-btn-bar__right">
                <Pager v-model="currentPage"
                       :total-items="redemptions.length"
                       :page-size="pageSize" />
            </div>
        </div>
    </div>
</template>

<script>
import ContactNameWithTitle from '@/epos/vue/components/Contacts/ContactNameWithTitle';
import DateFormat from '@/lib/Dates/DateFormat';
import momentFilter from '@/filters/moment';
import PageLoadingSpinner from '@/vue/components/PageLoadingSpinner';
import Pager from '@/vue/components/Pager';
import { apiResponseToError } from '@/lib/Api';
import { container } from '@/container';

export default {
    components: {
        ContactNameWithTitle,
        Pager,
        PageLoadingSpinner,
    },

    props: {
        /**
         * @type {Membership}
         */
        membership: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            redemptions: null,
            loadingRedemptions: false,
            currentPage: 1,
            pageSize: 10,
        };
    },

    computed: {
        paginatedRedemptions() {
            if (!this.redemptions) {
                return [];
            }

            const start = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            return this.redemptions.slice(start, end);
        },

        showPagination() {
            return this.redemptions && this.redemptions.length > this.pageSize;
        },
    },

    mounted() {
        this.loadRedemptionHistory();
    },

    methods: {
        formatDate(date) {
            return momentFilter(date, DateFormat.DATE_WITH_TIME);
        },

        getMemberByContactID(contactID) {
            if (!this.membership) {
                return null;
            }
            return this.membership.getMemberByContactID(contactID);
        },

        loadRedemptionHistory() {
            if (this.loadingRedemptions || this.redemptions !== null) {
                return;
            }

            this.loadingRedemptions = true;
            container.membershipRedemptionResource.query(
                {
                    membershipID: this.membership.ID,
                },
                (response) => {
                    this.redemptions = response;
                    this.loadingRedemptions = false;
                },
                (result) => {
                    const error = apiResponseToError(result);
                    container.toastFactory.errorTop('', error.message);
                    this.loadingRedemptions = false;
                }
            );
        },
    },
};
</script>
